module.exports = __webpack_public_path__ + "static/media/purchaseOption-bundleStory.6d60c304.svg";